import { trackPaymentErrors } from '@/helpers/facebookPixelEvents'

const apiUrl = process.env.REACT_APP_API_URL
const headers = {
  'Content-Type': 'application/json',
}

export const checkUserSubscription = async (email: string) => {
  try {
    const response = await fetch(`${apiUrl}/v1/user?email=${email}`, {
      method: 'GET',
      headers,
    })
    return await response.json()
  } catch (e) {
    trackPaymentErrors('createCustomer', e)
    return e
  }
}
